<template>
  <div>
    <van-row class="orderDetial">
      <van-col :span="24" class="bg-white detialItem">
        <p class="f-s-8 orderTitle">
          <van-icon name="checked" color="green" />
          交易成功
          <span
            class="f-l-r f-s-6"
            style="color:black"
            v-if="detial.orderType == 2"
            >拼团订单</span
          >
        </p>
        <div class="van-ellipsis f-s-8 m-t-05 orderContext">
          {{ detial.ctitle }}
        </div>
        <p class="text-r m-t-04">
          <span class="m-l-02 colorF1 f-s-7">¥</span
          ><span class="f-s-12 colorF1">{{ detial.coursePrice }}</span>
        </p>
        <p class="f-s-7 text-r m-t-3">
          实付<span class="m-l-02 colorF1">¥</span
          ><span class="f-s-12 colorF1">{{ detial.practicalPrice }}</span>
        </p>
        <!-- 拼团成员 -->
        <van-col :span="24" class="xzGroup bg-white p-t-05 m-t-3" v-if="detial.pinGroupUser != null">
          <p class="text-l f-s-6" style="color:#9DA4AD" >拼团成员</p>
          <van-row>
            <van-col :span="24" class="m-t-07 text-c">
              <div
                v-for="(item, index) in detial.pinGroupUser"
                :key="index"
                :style="{ position: index == 0 ? 'relative' : '' }"
                class="f-l-l m-l-08"
              >
                <van-image
                  width="2.35rem"
                  height="2.35rem"
                  round
                  :src="
                    item.headimgurl == undefined
                      ? questionMark
                      : item.headimgurl
                  "
                >
                </van-image>
                <van-tag
                  v-if="index == 0"
                  class="f-s-5 text-c Xzjy_chief"
                  color="#F89246"
                  text-color="#FFFFFF"
                  >团长</van-tag
                >
              </div>
            </van-col>
          </van-row>
        </van-col>
      </van-col>
      <van-col :span="24" class="bg-white detialItem m-t-05">
        <!-- 订单编号 -->
        <p class="f-s-7">
          <span class="cororAbb">订单编号：</span
          ><span class="colorBlack">{{ detial.orderNumber }}</span>
        </p>
        <p class="f-s-7 m-t-3">
          <span class="cororAbb">支付方式：</span
          ><span class="colorBlack">{{ detial.paymentway }}</span>
        </p>
        <p class="f-s-7 m-t-3">
          <span class="cororAbb">下单时间：</span
          ><span class="colorBlack">{{ detial.orderDate }}</span>
        </p>
        <p class="f-s-7 m-t-3">
          <span class="cororAbb">支付时间：</span
          ><span class="colorBlack">{{ detial.paymentDate }}</span>
        </p>
        <p class="f-s-7 m-t-3" v-if="detial.orderType == 2">
          <span class="cororAbb">拼单时间：</span
          ><span class="colorBlack">{{ detial.groupDate }}</span>
        </p>
        <p class="f-s-7 m-t-3">
          <span class="cororAbb">完成时间：</span
          ><span class="colorBlack">{{ detial.groupsucctime }}</span>
        </p>
      </van-col>
    </van-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      userCourseId: "", // 父页面传过来的id
      detial: {},
      questionMark: require("@/assets/imgs/live/questionMark.png"),
    };
  },
  created() {
    this.userCourseId = this.$route.query.userCourseId;
    this.getOrderDetails();
  },
  methods: {
    getOrderDetails() {
      let data = {
        userCourseId: this.userCourseId,
      };
      this.Api({
        url: "api/mine/getOrderDetails",
        method: "POST",
        data,
      }).then((res) => {
        this.detial = res.data;
      });
    },
  },
};
</script>

<style scoped>
.orderDetial {
  padding: 0.7rem 0.8rem 0rem 0.8rem;
}
.detialItem {
  padding: 0.7rem;
  border-radius: 0.2rem;
}
.orderContext {
  color: #292e35;
  font-weight: 500;
}
.orderTitle {
  border-bottom: 1px solid #f6f6f6;
  padding-bottom: 0.3rem;
}
.xzGroup {
  border-radius: 0.3rem;
}
.Xzjy_chief {
  position: absolute;
  left: 0.2rem;
  top: 1.8rem;
  width: 1.5rem;
  height: 0.8rem;
  line-height: 0.8rem;
  display: block;
  border-radius: 0.45rem;
}
</style>
